(() => {
  if (typeof window.customElements.get('bundle-atc-form') !== 'undefined') { return }

  window.customElements.define('bundle-atc-form', class BundleAddToCartForm extends HTMLElement {
    constructor () {
      super()

      this.widgetSubscriptionOption  = this.querySelector('[data-bsw-subscription-option]')
      this.subscriptionOptionChecked = this.widgetSubscriptionOption.querySelector('input[id="subscription"]')
      this.widgetSelector            = this.querySelector('[data-bsw-select-selling-plan]')
      this.secondDeliveryDate        = this.querySelector('[data-second-delivery-date]')
      this.sellingPlanFrequencies    = this.widgetSelector.getAttribute('data-bsw-select-selling-plan')
      this.bundleSellingPlans        = this.getAttribute('data-product-selling-plan-ids').split('|')
      this.bundleProductId           = this.querySelector('[data-bundle-product-id]')
      this.bundleVariantId           = this.querySelector('[data-selected-bundle-type-id]')
      this.atcButton                 = this.querySelector('[data-bundle-submit]')

      this.bundleItems     = null
      this.bundleEditURLs  = []            // track bundle instance(s) we may need to delete later

      this.initSelectListener()
      this.initBundleSubmit()
      // this.restoreBundleStateFromURL()
    }

    /* -------- CART DRAWER VISIBILITY -------- */
    toggleCartDrawer (show = true) {
      const drawer = document.querySelector('.quick-cart__wrapper')
      if (!drawer) return
      drawer.classList.toggle('active', show)
      document.body.toggleAttribute('data-fluorescent-overlay-open', show)
    }

    /* -------- SERIALISE CURRENT BUNDLE STATE -------- */
    generateBundleStateURL () {
      const bundleItems = this.querySelectorAll('bundle-item')
      const bundleState = []

      bundleItems.forEach(item => {
        const qtyInput = item.querySelector('[data-bqs-input]')
        bundleState.push({
          id           : item.dataset.bundleItemId,
          cid          : item.dataset.bundleItemCollectionId,
          quantity     : qtyInput.value,
          sellingPlans : item.dataset.bundleItemSellingPlanIds,
          title        : item.querySelector('.bundle-item__title').textContent,
          image        : item.querySelector('.bundle-item__image img').src,
          price        : item.dataset.bundleItem,
          comparePrice : item.dataset.bundleItemCompareAt,
          type         : item.dataset.bundleItemType
        })
      })

      const selectedBundleType = document.querySelector('[data-selected-bundle-type-id]')
      const bundleTypeId = selectedBundleType ? selectedBundleType.dataset.selectedBundleTypeId : ''

      const subscriptionChecked = this.subscriptionOptionChecked.checked
      const sellingPlanSelect   = document.querySelector('[data-bsw-selling-plan-select]')
      const sellingPlanPosition = sellingPlanSelect ? sellingPlanSelect.selectedIndex : 0
      const sellingPlanId       = subscriptionChecked && sellingPlanSelect ? sellingPlanSelect.value : ''

      const stateBase64 = btoa(JSON.stringify({
        items        : bundleState,
        bundleTypeId,
        subscription : subscriptionChecked,
        sellingPlanId,
        sellingPlanPos : sellingPlanPosition
      }))

      return `${window.location.pathname}?bundle=${stateBase64}`
    }

    /* -------- UPDATE “NEXT DELIVERY” DATE WHEN FREQUENCY CHANGES -------- */
    initSelectListener () {
      const monthFrequencies = this.sellingPlanFrequencies.split(',')

      const updateDate = () => {
        const pos = parseInt(this.widgetSelector.value)
        const months = parseInt(monthFrequencies[pos].trim())
        const today  = new Date()
        const locale = (window.Shopify.locale === 'fr' || window.location.pathname.includes('/fr/'))
          ? 'fr-FR' : 'en-GB'

        const future = new Date(today.getFullYear(), today.getMonth() + months, today.getDate())
        this.secondDeliveryDate.textContent = ' ' + future.toLocaleDateString(locale, {
          month : 'short', day : 'numeric', year : 'numeric'
        })
      }

      updateDate()
      this.widgetSelector.addEventListener('change', updateDate)
    }

    /* -------- HANDLE BUNDLE SUBMIT -------- */
    initBundleSubmit () {
      this.atcButton.addEventListener('click', async (e) => {
        e.preventDefault()
        this.toggleCartDrawer(false)                                  // hide drawer while updating

        this.bundleItems = this.querySelectorAll('bundle-item')
        const pos = parseInt(this.widgetSelector.value)

        /* ------- Build Recharge bundle descriptor ------- */
        const bundleProductData = {
          productId : this.bundleProductId.getAttribute('data-bundle-product-id'),
          variantId : this.bundleVariantId.getAttribute('data-selected-bundle-type-id'),
          handle    : this.bundleVariantId.getAttribute('data-selected-bundle-parent'),
          ...(this.subscriptionOptionChecked.checked && {
            sellingPlan : this.bundleSellingPlans[pos]
          })
        }

        const bundleDescriptor = {
          externalVariantId  : bundleProductData.variantId,
          externalProductId  : bundleProductData.productId,
          selections         : []
        }

        this.bundleItems.forEach(item => {
          const qty  = item.querySelector('[data-bqs-input]').value
          let planId = null
          if (item.dataset.bundleItemSellingPlanIds && this.subscriptionOptionChecked.checked) {
            planId = item.dataset.bundleItemSellingPlanIds.split('|')[pos]
          }

          const entry = {
            collectionId      : item.dataset.bundleItemCollectionId,
            externalProductId : item.dataset.bundleItemId,
            externalVariantId : item.dataset.bundleItemId,
            quantity          : qty
          }
          if (planId) entry.sellingPlan = planId
          bundleDescriptor.selections.push(entry)
        })

        /* ------- Get the actual Shopify line-items for this bundle ------- */
        const cartItems = await recharge.bundle.getDynamicBundleItems(bundleDescriptor, bundleProductData.handle)
        const bundleStateURL = this.generateBundleStateURL()

        /* Stamp helper props onto each line-item so we can find/remove later */
        const stamp = Date.now()
        cartItems.forEach(li => {
          li.properties = {
            ...(li.properties || {}),
            _key             : `${li.id}:${stamp}`,
            _bundle_item     : 'bundle_item',
            _bundle_state_url: bundleStateURL
          }
        })

        /* ------- Delete previous version (if editing) ------- */
        if (this.bundleEditURLs.length) {
          for (const url of this.bundleEditURLs) {
            await fetch('/cart/change.js', {
              method : 'POST',
              headers: { 'Content-Type':'application/json' },
              body   : JSON.stringify({ id:url, quantity:0 })
            })
          }
        }

        /* ------- Add NEW version ------- */
        await fetch(`${window.Shopify.routes.root}cart/add.js`,{
          method : 'POST',
          headers: { 'Content-Type':'application/json' },
          body   : JSON.stringify({ items: cartItems })
        })

        /* Track this version so we can delete on next edit */
        this.bundleEditURLs = [bundleStateURL]

        try {
          /* ------- Clean up any stray lines for same bundle in cart ------- */
          const cart       = await fetch('/cart.js').then(r => r.json())
          const updates    = {}
          const currentURL = window.location.pathname + window.location.search

          cart.items.forEach(item => {
            if (item.properties && item.properties._bundle_state_url === currentURL && item.key) {
              updates[item.key] = 0
            }
          })

          if (Object.keys(updates).length) {
            await fetch('/cart/update.js', {
              method : 'POST',
              headers: { 'Content-Type':'application/json' },
              body   : JSON.stringify({ updates })
            })
          }

          /* ------- Refresh the Stiletto quick-cart ------- */
          if (window.fluorescent?.Cart?.fetchAndRender) {
            await window.fluorescent.Cart.fetchAndRender()
          } else {
            /* -------- ORIGINAL FALLBACK WITH “START OVER” BUTTON -------- */
            document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart } }))

            const inputItems = document.querySelectorAll('[data-input-item]')
            inputItems.forEach(node => {
              if (currentURL === node.dataset.key) {
                node.remove()
                const checkoutBtn = document.querySelector('.product-form__cart-submit')
                if (checkoutBtn) {
                  const locale = window.Shopify.locale; 
                  let lang;
                  if (locale == 'en'){
                    lang = 'Start Over'
                  }
                  if (locale == 'fr'){
                    lang = 'Recommencer'
                  }
                  const startOver = document.createElement('a')
                  startOver.className = 'product-form__cart-submit btn btn--medium btn--full btn--primary start-over-button'
                  startOver.href      = '/products/deodorant'
                  startOver.textContent = lang
                  checkoutBtn.parentNode.insertBefore(startOver, checkoutBtn)
                  checkoutBtn.remove()
                }
              }
            })
          }

          /* Fire the canonical Stiletto event **after** everything is final */
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'))

          this.toggleCartDrawer(true)                                // reopen drawer

        } catch (err) {
          console.error('Bundle update error:', err)
          this.toggleCartDrawer(true)                                // still reopen drawer
        }
      })
    }
  })
})()
